import { Dispatch, SetStateAction, useCallback, useEffect, useState } from 'react';
import { getUiPreference, setUiPreference } from '../lib/uiPreferences';

export function usePersistedReveal(
  key: string,
  defaultValue = false,
): [boolean, Dispatch<SetStateAction<boolean>>] {
  const [revealed, setRevealedState] = useState<boolean>(() =>
    getUiPreference<boolean>(key, defaultValue),
  );

  useEffect(() => {
    setRevealedState(getUiPreference<boolean>(key, defaultValue));
  }, [key, defaultValue]);

  useEffect(() => {
    const handleReset = () => setRevealedState(defaultValue);
    window.addEventListener('ui-preferences-reset', handleReset);
    return () => window.removeEventListener('ui-preferences-reset', handleReset);
  }, [defaultValue]);

  const setRevealed = useCallback<Dispatch<SetStateAction<boolean>>>(
    (value) => {
      setRevealedState((prev) => {
        const next = typeof value === 'function' ? (value as (p: boolean) => boolean)(prev) : value;
        setUiPreference(key, next);
        return next;
      });
    },
    [key],
  );

  return [revealed, setRevealed];
}
